'use client';

import { c as _c } from "react/compiler-runtime";
import posthog from 'posthog-js';
import { PostHogProvider as Provider } from 'posthog-js/react';
import { useEffect, useRef } from 'react';
import type { PropsWithChildren } from 'react';
import { useEnvironment } from './useEnvironment';
import { useUser } from './useUser';
const isExcludedUser = (email?: string, name?: string): boolean => email?.endsWith('support@eon.io') === true || name?.toLowerCase().includes('eon support') === true;
export const PostHogProvider = props => {
  const $ = _c(14);
  const {
    user,
    currentProjectId
  } = useUser();
  const {
    posthogKey
  } = useEnvironment();
  let t0;
  if ($[0] !== posthogKey || $[1] !== user) {
    t0 = !!user?.id && !!posthogKey && !isExcludedUser(user.email, user.givenName);
    $[0] = posthogKey;
    $[1] = user;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const enabled = t0;
  const initialized = useRef(false);
  let t1;
  let t2;
  if ($[3] !== enabled || $[4] !== posthogKey) {
    t1 = () => {
      if (!enabled || !posthogKey || initialized.current) {
        return;
      }
      posthog.init(posthogKey, {
        api_host: "/ingest",
        ui_host: "https://us.posthog.com",
        person_profiles: "identified_only",
        mask_all_text: true,
        mask_all_element_attributes: true,
        mask_personal_data_properties: true,
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: "*"
        }
      });
      initialized.current = true;
    };
    t2 = [enabled, posthogKey];
    $[3] = enabled;
    $[4] = posthogKey;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[7] !== currentProjectId || $[8] !== enabled || $[9] !== user) {
    t3 = () => {
      if (!enabled || !user?.id) {
        return;
      }
      posthog.identify(user.id, {
        email: user.email,
        name: user.givenName,
        project: currentProjectId,
        eonAccountId: user.eonAccount.id
      });
    };
    t4 = [enabled, user, currentProjectId];
    $[7] = currentProjectId;
    $[8] = enabled;
    $[9] = user;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  useEffect(t3, t4);
  if (!enabled) {
    return props.children;
  }
  let t5;
  if ($[12] !== props.children) {
    t5 = <Provider client={posthog}>{props.children}</Provider>;
    $[12] = props.children;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};